import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { PageHeader, Banner } from '../utils'
import img from '../images/bcg/contactBcg.jpeg'
import ContactInfo from "../components/HomePageComponents/ContactInfo"

const ContactPage = () => (
  <Layout>
    <SEO title="Contact" />
    <PageHeader img={img}>
    <Banner title="Contact Us" subtitle=""></Banner>
    </PageHeader>
    <ContactInfo/>
  </Layout>
)

export default ContactPage
